import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";

function authHeaders() {
  return { credentials: "include" };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export async function fetchMarketplaceHealthSummary(range = "last_30_days", filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/marketplace${qs({ range, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics del marketplace.");
  return res.json();
}

export async function fetchSupplyAnalytics(range = "last_30_days", filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/supply${qs({ range, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de oferta.");
  return res.json();
}

export async function fetchDemandAnalytics(range = "last_30_days", filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/demand${qs({ range, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de demanda.");
  return res.json();
}

export async function fetchCityAnalytics(range = "last_30_days", filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/cities${qs({ range, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics por ciudad.");
  return res.json();
}

export async function fetchPricingAnalytics(range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/pricing${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de precios.");
  return res.json();
}

export async function fetchInventoryHealthAnalytics(range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/inventory-health${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar salud de inventario.");
  return res.json();
}

export async function fetchTrustSafetyMarketplaceAnalytics(range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/trust-safety${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de confianza.");
  return res.json();
}

export async function fetchSeoMarketplaceAnalytics(range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/seo${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics SEO.");
  return res.json();
}

export async function fetchCampaignMarketplaceAnalytics(range = "last_30_days", filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/campaigns${qs({ range, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de campañas.");
  return res.json();
}

export async function fetchMarketplaceFunnel(range = "last_30_days", filters = {}) {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/marketplace/funnel${qs({ range, ...filters })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar embudo del marketplace.");
  return res.json();
}

export async function exportMarketplaceAnalyticsCsv(range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/marketplace/export${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo exportar reporte.");
  const blob = await res.blob();
  const filename =
    res.headers.get("Content-Disposition")?.match(/filename="(.+)"/)?.[1] ||
    `automap-marketplace-${range}.csv`;
  return { blob, filename };
}
